// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Flyttet ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + '-handling fuldført',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + '-handling i gang',
  accColorPalette: () => 'Farvepalet',
  accColorSwatch: () => 'Farvebytning',
  accCommandKey: () => 'Kommando',
  accContextMenuLabel: () => 'handlinger',
  accControlKey: () => 'Luk',
  accPositionAfter: () => 'efter',
  accPositionBefore: () => 'før',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Hold ' + p['keyPressed'] + ' og Shift nede, og anvend derefter piletasterne til at omsortere.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Indtast en komplet dato som denne: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Indtast en måned og et år som dette: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Label',
  chart_labelGroup: () => 'Gruppe',
  chart_labelSeries: () => 'Serier',
  chart_labelValue: () => 'Værdi',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Vælg en værdi.',
  checkbox_helpForCheckbox: () => 'Hjælp til afkrydsningsfelt',
  checkbox_requiredMessageDetail: () => 'Vælg en værdi.',
  checkbox_selected: () => 'Afkrydsningsfelt markeret',
  checkbox_unselected: () => 'Afkrydsningsfelt ikke markeret',
  close: () => 'Luk',
  collection_apply: () => 'Anvend',
  collection_cancel: () => 'Annuller',
  collection_loaded: () => 'Indlæst',
  collection_loading: () => 'Indlæser',
  collection_noData: () => 'Ingen data at vise.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Tilpas størrelse på kolonne',
  collection_resizeColumnMenu: () => 'Tilpas størrelse på kolonne...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Indtast et tal mellem ' + p['MIN'] + ' og ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Vælg alle rækker',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vælg rækken ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Stigende',
  collection_sortColumnMenu: () => 'Sorter kolonne',
  collection_sortDescendingSubMenu: () => 'Faldende',
  collection_sortDisabled: () => 'Kan ikke sorteres',
  collection_sortEnabled: () => 'Kan sorteres',
  collection_width: () => 'Bredde',
  colorPicker_label: () => 'Farvevælger',
  confirmation: () => 'Bekræftelse',
  datePicker_currentDate: () => 'Aktuel dato',
  datePicker_goToToday: () => 'Gå til i dag',
  datePicker_label: () => 'Datovælger',
  datePicker_month: () => 'Måned',
  datePicker_months: () => 'Måneder',
  datePicker_next: () => 'Næste',
  datePicker_nextDecade: () => 'Næste årti',
  datePicker_nextMonth: () => 'Næste måned',
  datePicker_prev: () => 'Forrige',
  datePicker_prevDecade: () => 'Forrige årti',
  datePicker_prevMonth: () => 'Forrige måned',
  datePicker_restricted: () => 'Begrænset',
  datePicker_selected: () => 'Valgt',
  datePicker_today: () => 'I dag',
  datePicker_weekNum: (p: { NUM: string }) => 'Uge ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Ugenummer',
  datePicker_year: () => 'År',
  datePicker_years: () => 'År ',
  diagram_promotedLink: () => '1 link',
  diagram_promotedLinkAriaDesc: () => 'Indirekte',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' links',
  error: () => 'Fejl',
  expandableList_expandCollapseInstructionText: () => 'Brug piletaster til at udvide og skjule',
  expandableList_groupCollapse: () => 'Skjult',
  expandableList_groupExpand: () => 'Udvidet',
  filePicker_addFiles: () => 'Tilføj filer',
  filePicker_dropzonePrimaryText: () => 'Træk og slip',
  filePicker_dropzoneSecondaryText: () => 'Vælg en fil, eller slip en her',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vælg eller slip filer her',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Du kan ikke uploade filer af typen: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Upload en fil ad gangen',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Du kan ikke uploade filer af typen ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'ukendt',
  formControl_clear: () => 'Ryd',
  formControl_day: () => 'Dag',
  formControl_empty_segment: () => 'Tom',
  formControl_helpAvailable: () => 'Hjælp tilgængelig',
  formControl_hide: () => 'Skjul',
  formControl_hour: () => 'Time',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Du har nået grænsen på ' +
    ((
      { one: new Intl.NumberFormat('da').format(p['CHARACTER_LIMIT']) + ' tegn' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('da').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('da').format(p['CHARACTER_LIMIT']) + ' tegn') +
    '.',
  formControl_loading: () => 'Indlæser',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Du kan indtaste op til ' + p['MAX_LENGTH'] + ' tegn.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimumlængden ' + p['MAX_LENGTH'] + ' er overskredet.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tegn tilbage.',
  formControl_millisecond: () => 'Millisekund ',
  formControl_minute: () => 'Minut',
  formControl_month: () => 'Måned',
  formControl_readOnly: () => 'Skrivebeskyttet',
  formControl_requiredMessageDetail: () => 'Indtast en værdi.',
  formControl_second: () => 'Sekund',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'Vælg ' + p['n'] + ' værdier.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Du har nået grænsen på ' + p['max'] + ' valg.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Vælg ' + p['min'] + ' til ' + p['max'] + ' værdier.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Vælg mindst ' + p['min'] + ' værdier.',
  formControl_show: () => 'Vis',
  formControl_year: () => 'År',
  gantt_labelDate: () => 'Dato',
  gantt_labelEnd: () => 'Slut',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Række',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Intet matchende afsnit fundet.',
  indexer_keyboardInstructionText: () => 'Tryk på Enter for at vælge en værdi.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mellem ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dobbelttryk og hold for at aktivere bevægelsestilstand. Træk derefter op eller ned for at justere værdien.',
  info: () => 'Oplysninger',
  inputColor_selectColor: () => 'Vælg en farve',
  inputDateMask_date_cleared: () => 'Dato ryddet',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tom',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'åååå',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Indtast en dato, der ligger samtidig med eller før ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Indtast en dato, der ligger samtidig med eller efter ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Indtast en tilgængelig dato.',
  inputDatePicker_instruction: () => 'Tryk på Tab for at åbne kalenderen.',
  inputDatePicker_selectDate: () => 'Vælg en dato',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Indtast en måned og et år på eller før ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Indtast en måned og et år på eller efter ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Indtast et tal.',
  inputNumber_decrease: () => 'Formindsk',
  inputNumber_increase: () => 'Forøg',
  inputPassword_hidden: () => 'Adgangskode skjult',
  inputPassword_hide: () => 'Skjul adgangskode',
  inputPassword_show: () => 'Vis adgangskode',
  inputSensitiveText_hidden: () => 'Følsom tekst skjult',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Indtast et tidspunkt, der er ' + p['max'] + ' eller tidligere.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Indtast et tidspunkt, der er ' + p['min'] + ' eller senere.',
  inputTimeMask_time_cleared: () => 'Rydningstidspunkt',
  labelNone: () => 'Ingen',
  list_msgFetchCompleted: () => 'Indlæst',
  list_msgFetchingData: () => 'Indlæser',
  list_suggestion: () => 'Forslag',
  menu_stateLoading: () => 'Indlæser',
  messageToast_allMessagesClosed: () => 'Alle toast-meddelelser er lukket.',
  message_close: () => 'Luk',
  message_confirmation: () => 'Gennemført',
  message_error: () => 'Fejl',
  message_info: () => 'Oplysninger',
  message_navigationFromMessagesRegion: () =>
    'Område til indtastning af meddelelser. Tryk på F6 for at navigere.',
  message_navigationToMessagesRegion: () =>
    'Meddelelsesområde har nye meddelelser. Tryk på F6 for at navigere.',
  message_navigationToTouch: () => 'Meddelelsesområde har nye meddelelser.',
  message_warning: () => 'Advarsel',
  noData_message: () => 'Ingen elementer at vise',
  overflowItemLabel: () => 'Flere faner',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Dobbelttryk for at lukke det åbne pop-op-vindue.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Åbner pop-op. Tryk på F6 for at navigere mellem pop-op og det tilknyttede kontrolelement.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Pop-op er åben. Tryk på F6 for at navigere mellem pop-op og det tilknyttede kontrolelement.',
  progressIndeterminate: () => 'I gang',
  radioButton_checked: () => 'Alternativknap markeret',
  radioButton_selected: () => 'Alternativknap valgt',
  radioButton_unchecked: () => 'Alternativknap ikke markeret',
  radioButton_unselected: () => 'Alternativknap ikke valgt',
  radio_helpForRadio: () => 'Hjælp til alternativknap',
  radio_requiredMessageDetail: () => 'Vælg en værdi.',
  selectMultiple_apply: () => 'Anvend',
  selectMultiple_back: () => 'Tilbage',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Brug venstre og højre piletast til at fremhæve valgte værdier.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Tryk på Tilbage eller Slet for at fjerne den valgte værdi.',
  selectMultiple_selectedValues: () => 'Valgte værdier',
  selectMultiple_showSelectedValues: () => 'Vis kun valgte værdier.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' værdier valgt.',
  select_addToList: () => 'Føj til liste',
  select_addToListAvailable: () => 'Føj til liste tilgængelig',
  select_closeDropdown: () => 'Tryk på Escape for at lukke.',
  select_moreSearchOptions: () => 'Flere søgemuligheder',
  select_moreSearchOptionsAvailable: () => 'Flere søgemuligheder tilgængelige',
  select_noMatchesFound: () => 'Ingen matchninger blev fundet.',
  select_oneMatchFound: () => 'Én matchning blev fundet',
  select_requiredMessageDetail: () => 'Vælg en værdi.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches fundet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eller flere matches fundet',
  selectorAll_deselectAll: () => 'Fravælg alle',
  selectorAll_selectAll: () => 'Vælg alle',
  selector_selected: () => 'Afkrydsningsfelt markeret',
  selector_unselected: () => 'Afkrydsningsfelt ikke markeret',
  sheet_close: () => 'Luk',
  switch_off: () => 'Fra',
  switch_on: () => 'Til',
  tabBarNavigationList_removeCueText: () => 'Kan fjernes',
  tabBar_tabContainsErrors: () => 'Indeholder fejl',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Fjernede ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'har kontekstmenu',
  tabbar_labelMoveLeft: () => 'Flyt til venstre',
  tabbar_labelMoveRight: () => 'Flyt til højre',
  tabbar_labelRemove: () => 'Fjern',
  timeComponent_tooltipZoomIn: () => 'Zoom ind',
  timeComponent_tooltipZoomOut: () => 'Zoom ud',
  timeConverter_parseError: () => 'Indtast et komplet tidspunkt.',
  train_current: () => 'Aktuel',
  train_message_type: () => 'Meddelelsestype',
  train_not_visited: () => 'Ikke besøgt',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Trin ' + p['currentStep'] + ' af ' + p['numberOfSteps'],
  train_visited: () => 'Besøgt',
  userAssistance_learnMore: () => 'Lær mere',
  userAssistance_required: () => 'Påkrævet',
  vis_clearSelection: () => 'Ryd valg',
  vis_drillable: () => 'Kan bores',
  vis_invalidData: () => 'Ugyldige data',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' af ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Marquee-valg',
  vis_marqueeZoomTooltip: () => 'Marquee-zoom',
  vis_noData: () => 'Ingen data at vise',
  vis_panTooltip: () => 'Panorer',
  vis_stateCollapsed: () => 'Skjult',
  vis_stateExpanded: () => 'Udvidet',
  vis_stateLoaded: () => 'Indlæst',
  vis_stateLoading: () => 'Indlæser',
  vis_stateSelected: () => 'Valgt',
  vis_stateUnselected: () => 'Ikke valgt',
  warn: () => 'Advarsel'
};
export default bundle;
